//to be used with code_explorer lib


const maxIterationsDefault = 5000


function InfiniteLoopDetector ({maxIterations = maxIterationsDefault, maxChildrenIterations = maxIterations * 4} = {}) {


    let loops = {}



    //has to be used as loopInsideCallback with code_explorer
    this.insideCallback = function (data) {
        let loopKey = `${data.sourceName}_${data.line}_${data.column}`

        if (!loops[loopKey]) {
            init(loopKey)
        }

        loops[loopKey].iterations += 1

        if (loops[loopKey].iterations > maxIterations) {
            delete loops[loopKey]
            let error = new Error(`Infinite (or more than ${maxIterations} iterations) loop detected !`)
            error.isInfiniteLoop = true //FIXME do better
            throw error
        }

    }


    //has to be used as loopAfterCallback with code_explorer
    this.afterCallback = function (data) {
        let loopKey = `${data.sourceName}_${data.line}_${data.column}`

        //loop was never entered
        if (!loops[loopKey]) {
            return
        }

        let parentLoopKeys = loops[loopKey].parentLoops

        for (let i = 0; i < parentLoopKeys.length; i++) {
            let parentLoopKey = parentLoopKeys[i]
            let parentLoop    = loops[parentLoopKey]
            parentLoop.childrenIterations += loops[loopKey].iterations

            if (parentLoop.childrenIterations > maxChildrenIterations) {
                delete loops[parentLoopKey]
                let error = new Error(`Infinite (or more than ${maxChildrenIterations} iterations) loop within a loop detected !`)
                error.isInfiniteLoop = true //FIXME do better
                throw error
            }
        }

        delete loops[loopKey]
    }



    function init (loopKey) {
        let parentLoops = []
        for (let parentLoop in loops) {
            parentLoops.push(parentLoop)
        }
        loops[loopKey] = {
            iterations:         0,
            childrenIterations: 0,
            parentLoops
        }
    }


}


export default InfiniteLoopDetector
